export interface BannerItem {
  banner_id: string;
  banner_text: string;
  button_text: string;
  button_url: string;
  banner_style?: string;
}

export interface BannerResponse {
  results: BannerItem[];
}

/**
 * Fetches the active banner via the Next.js /api/banners proxy route.
 * The proxy calls the middleware server-side, avoiding CORS from the browser.
 * Returns null on any error so the UI silently hides the banner.
 */
export async function getBanners(language = 'en'): Promise<BannerResponse | null> {
  try {
    const response = await fetch(`/api/banners?lang=${language}`, {
      method: 'GET',
    });

    if (!response.ok) {
      return null;
    }

    const data: BannerResponse = await response.json();
    return data;
  } catch {
    return null;
  }
}
